import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import * as pdfjsLib from 'pdfjs-dist';
import '../CSS/Archives.css';

// Configure pdf.js worker
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

/* ── SVG icon helpers ── */
const IconArchive = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 8v13H3V8"/><path d="M1 3h22v5H1z"/><path d="M10 12h4"/></svg>
);
const IconBook = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
);
const IconEye = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
);
const IconCalendar = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
);
const IconDownload = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
);
const IconChevronLeft = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
);
const IconChevronRight = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
);
const IconX = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
);
const IconFileText = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
);
const IconSend = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
);
const IconClock = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
);
const IconArrowLeft = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
);
const IconUser = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
);

/* ── Volume/Issue data ── */
const archivesData = [
    {
        volume: 1,
        year: '2026',
        issues: [
            {
                issue: 1,
                title: 'Inaugural Issue',
                date: 'January 2026',
                status: 'published',
                pdfPath: '/archives/Volume-1/Issue-1/vol1_issue1_2026.pdf',
                articles: [
                    {
                        number: 1,
                        title: 'Enhancing Machine Learning Model Security in Private Cloud Environments through Cryptographic Techniques',
                        authors: 'Ayesha Siddiqui, Mohd Kaif Malik, Mohd Naved Ul Haq, Mohd Nafees',
                        pdfPath: '/archives/Volume-1/Issue-1/pdfforlandingpage/Article_01.pdf',
                    },
                    {
                        number: 2,
                        title: 'Advancement in Machine Learning & Deep Learning for Healthcare & Medical Imaging',
                        authors: 'Avni Patel, Dr. Ramesh T. Prajapati',
                        pdfPath: '/archives/Volume-1/Issue-1/pdfforlandingpage/Article_02.pdf',
                    },
                    {
                        number: 3,
                        title: 'A Study on the Effectiveness of Cardiopulmonary Resuscitation (CPR) Training Program on Knowledge and Practice Among Nursing Students',
                        authors: 'Neha Rautela',
                        pdfPath: '/archives/Volume-1/Issue-1/pdfforlandingpage/Article_03.pdf',
                    },
                    {
                        number: 4,
                        title: 'FedGeoScale: Entropy-Driven Dynamic Geo-Clustering with Over-the-Air Personalized Federated Learning',
                        authors: 'Manish Kumar, Mushtaq Ahmad Rather',
                        pdfPath: '/archives/Volume-1/Issue-1/pdfforlandingpage/Article_04.pdf',
                    },
                    {
                        number: 5,
                        title: 'Art Generation with Neural Style Transfer',
                        authors: 'Priyanka Vashisht, Anvesha Katti, Gregory Wayne Wickham',
                        pdfPath: '/archives/Volume-1/Issue-1/pdfforlandingpage/Article_05.pdf',
                    },
                    {
                        number: 6,
                        title: 'Flexible Vivaldi Antenna for Medical Imaging Application',
                        authors: 'Lucky Verma, Rahul Kumar Singh, Manish Kumar',
                        pdfPath: '/archives/Volume-1/Issue-1/pdfforlandingpage/Article_06.pdf',
                    },
                    {
                        number: 7,
                        title: 'Artificial Intelligence: A Double-Edged Sword in Cybercrime',
                        authors: 'Jyoti Kaurav, Vikash Patel, Vishvajeet Yadav',
                        pdfPath: '/archives/Volume-1/Issue-1/pdfforlandingpage/Article_07.pdf',
                    },
                    {
                        number: 8,
                        title: 'Review: Laplacian Energy of Signed Graphs — Analytical Bounds, Degree-Based Structures, and Spectral Signatures',
                        authors: 'Indu Bala, Anshu Malhotra, Nishu',
                        pdfPath: '/archives/Volume-1/Issue-1/pdfforlandingpage/Article_08.pdf',
                    },
                ],
            },
            {
                issue: 2,
                title: 'AI-Enabled Engineering Systems for Healthcare & Life Sciences',
                date: 'July 2026',
                status: 'published',
                pdfPath: '/archives/Volume-1/Issue-2/vol1_issue2_2026.pdf',
                articles: [
                    {
                        number: 1,
                        title: 'AI-Powered NLP for Misinformation Detection in Digital News',
                        authors: 'Ishita Mullick, Udita Thakur, Hritik Kumar Singh, Priyanshu Jha, Nigmanshu Jha, Bhavna Nayyer',
                        pdfPath: '/archives/Volume-1/Issue-2/ITME_V1I2_01.pdf',
                    },
                    {
                        number: 2,
                        title: 'An Integrated AI-IoT Architecture for Real-Time Healthcare Monitoring and Intelligent Decision Support',
                        authors: 'Amit Kumar Singh, Ankit Srivastava',
                        pdfPath: '/archives/Volume-1/Issue-2/ITME_V1I2_02.pdf',
                    },
                    {
                        number: 3,
                        title: 'AI for Personalized Medicine and Clinical Decision Support',
                        authors: 'Surabhi Shanker, Saloni Shanker',
                        pdfPath: '/archives/Volume-1/Issue-2/ITME_V1I2_03.pdf',
                    },
                    {
                        number: 4,
                        title: 'A Cloud-Based AI Content and Productivity Platform Using Unified Workflow Orchestration',
                        authors: 'Pratham Sood, Chirag Bhateja, Ayush Dhingra, Vaidik Sharma',
                        pdfPath: '/archives/Volume-1/Issue-2/ITME_V1I2_04.pdf',
                    },
                    {
                        number: 5,
                        title: 'FedXAI-Health: Privacy-Protected Explainable Federated Deep Learning Model in Pre-emption of Early Diseases with Multimodal Healthcare Data',
                        authors: 'Kaljot Sharma, Neetu Rani',
                        pdfPath: '/archives/Volume-1/Issue-2/ITME_V1I2_05.pdf',
                    },
                    {
                        number: 6,
                        title: 'Infrastructure Automation Using Terraform on Cloud Platforms',
                        authors: 'Bhavna Nayyer, Annika Bajaj, Karamjot Kaur, Neha Singal, Piyush Kukreja, Preet Millu',
                        pdfPath: '/archives/Volume-1/Issue-2/ITME_V1I2_06.pdf',
                    },
                    {
                        number: 7,
                        title: 'Role of Artificial Intelligence in Understanding and Managing Infertility: From Diagnosis to Therapeutics',
                        authors: 'Vikas, Awaneet Kaur, Ashutosh Singh',
                        pdfPath: '/archives/Volume-1/Issue-2/ITME_V1I2_07.pdf',
                    },
                    {
                        number: 8,
                        title: 'Artificial Intelligence in Depression Care: From Early Detection to Personalized Treatment and Future Directions',
                        authors: 'Divyanshu Singh, Ashutosh Singh, Awaneet Kaur, Debashis Pramanick',
                        pdfPath: '/archives/Volume-1/Issue-2/ITME_V1I2_08.pdf',
                    },
                    {
                        number: 9,
                        title: 'Transformation of Internet of Medical Things in Healthcare: Architecture and Security',
                        authors: 'Javed Azmi',
                        pdfPath: '/archives/Volume-1/Issue-2/ITME_V1I2_09.pdf',
                    },
                ],
            },
        ],
    },
];

/* ── PDF Viewer Modal using pdfjs-dist ── */
const PdfViewerModal = ({ pdfUrl, title, onClose }) => {
    const [numPages, setNumPages] = useState(null);
    const [pageNum, setPageNum] = useState(1);
    const [loading, setLoading] = useState(true);
    const [pdfDoc, setPdfDoc] = useState(null);
    const canvasRef = useRef(null);

    // Load the PDF document
    useEffect(() => {
        let cancelled = false;
        setLoading(true);

        const loadPdf = async () => {
            try {
                const doc = await pdfjsLib.getDocument(pdfUrl).promise;
                if (!cancelled) {
                    setPdfDoc(doc);
                    setNumPages(doc.numPages);
                    setPageNum(1);
                    setLoading(false);
                }
            } catch (err) {
                console.error('Error loading PDF:', err);
                if (!cancelled) setLoading(false);
            }
        };
        loadPdf();
        return () => { cancelled = true; };
    }, [pdfUrl]);

    // Render a page to canvas
    useEffect(() => {
        if (!pdfDoc || !canvasRef.current) return;
        let cancelled = false;

        const renderPage = async () => {
            try {
                const page = await pdfDoc.getPage(pageNum);
                const viewport = page.getViewport({ scale: 1.5 });
                const canvas = canvasRef.current;
                const context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width;

                await page.render({ canvasContext: context, viewport }).promise;
            } catch (err) {
                if (!cancelled) console.error('Error rendering page:', err);
            }
        };
        renderPage();
        return () => { cancelled = true; };
    }, [pdfDoc, pageNum]);

    // Close on Escape
    useEffect(() => {
        const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [onClose]);

    // Prevent body scroll
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = ''; };
    }, []);

    return (
        <div className="archives-modal-overlay" onClick={onClose}>
            <div className="archives-modal" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="archives-modal-header">
                    <span className="archives-modal-title">
                        <IconFileText /> {title}
                    </span>
                    <div className="archives-modal-controls">
                        <button className="archives-modal-nav-btn" disabled={pageNum <= 1} onClick={() => setPageNum((p) => p - 1)} title="Previous page">
                            <IconChevronLeft />
                        </button>
                        {numPages && <span className="archives-modal-page-info">Page {pageNum} / {numPages}</span>}
                        <button className="archives-modal-nav-btn" disabled={!numPages || pageNum >= numPages} onClick={() => setPageNum((p) => p + 1)} title="Next page">
                            <IconChevronRight />
                        </button>
                        <button className="archives-modal-close-btn" onClick={onClose} title="Close">
                            <IconX />
                        </button>
                    </div>
                </div>

                {/* Body */}
                <div className="archives-modal-body">
                    {loading ? (
                        <div className="archives-pdf-loading">
                            <div className="archives-pdf-spinner" />
                            <span>Loading PDF…</span>
                        </div>
                    ) : (
                        <div className="archives-pdf-canvas-wrapper">
                            <canvas ref={canvasRef} />
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="archives-modal-footer">
                    <a
                        className="archives-modal-download-btn"
                        href={pdfUrl}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <IconDownload /> Download PDF
                    </a>
                </div>
            </div>
        </div>
    );
};

/* ── Issue Articles View ── */
const IssueArticlesView = ({ issue, volume, onBack, onViewPdf }) => {
    return (
        <div className="archives-issue-detail">
            {/* Issue detail header */}
            <div className="archives-issue-detail-header">
                <button className="archives-back-btn" onClick={onBack}>
                    <IconArrowLeft /> Back to Volumes
                </button>
                <div className="archives-issue-detail-meta">
                    <span className="archives-issue-detail-badge">
                        Volume {volume}, Issue {issue.issue}
                    </span>
                    <span className={`archives-issue-status ${issue.status}`}>
                        {issue.status === 'published' ? '● Published' : '◷ Coming Soon'}
                    </span>
                </div>
                <h2 className="archives-issue-detail-title">{issue.title}</h2>
                <p className="archives-issue-detail-date">
                    <IconCalendar /> {issue.date}
                </p>
            </div>

            {/* Articles count */}
            <div className="archives-articles-count">
                <IconFileText />
                <span>{issue.articles.length} Articles in this Issue</span>
            </div>

            {/* Articles list */}
            <div className="archives-articles-list">
                {issue.articles.map((article) => (
                    <div className="archives-article-card" key={article.number}>
                        <div className="archives-article-number">
                            {String(article.number).padStart(2, '0')}
                        </div>
                        <div className="archives-article-info">
                            <h3 className="archives-article-title">{article.title}</h3>
                            <div className="archives-article-authors">
                                <IconUser />
                                <span>{article.authors}</span>
                            </div>
                        </div>
                        <div className="archives-article-actions">
                            <button
                                className="archives-view-pdf-btn"
                                onClick={() => onViewPdf(article.pdfPath, article.title)}
                                title="View PDF"
                            >
                                <IconEye /> View PDF
                            </button>
                            <a
                                className="archives-download-pdf-btn"
                                href={article.pdfPath}
                                download
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Download PDF"
                            >
                                <IconDownload />
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

/* ── Main Archives Page ── */
const Archives = () => {
    const [viewerOpen, setViewerOpen] = useState(false);
    const [activePdf, setActivePdf] = useState({ url: '', title: '' });
    const [activeIssue, setActiveIssue] = useState(null); // { issue, volume }

    const openViewer = useCallback((url, title) => {
        setActivePdf({ url, title });
        setViewerOpen(true);
    }, []);

    const closeViewer = useCallback(() => {
        setViewerOpen(false);
        setActivePdf({ url: '', title: '' });
    }, []);

    const openIssue = useCallback((issue, volume) => {
        setActiveIssue({ issue, volume });
    }, []);

    const closeIssue = useCallback(() => {
        setActiveIssue(null);
    }, []);

    return (
        <div className="archives-page">
            {/* ── Hero ── */}
            <div className="archives-hero">
                <div className="archives-hero-badge">
                    <IconArchive />
                    Journal Archives
                </div>
                <h1>Published Volumes &amp; Issues</h1>
                <p className="archives-hero-subtitle">
                    Browse the complete collection of peer-reviewed research published in Innovative Trends in Multidisciplinary Engineering.
                </p>
            </div>

            {/* ── Content ── */}
            <div className="archives-content">
                {activeIssue ? (
                    /* ── Issue Detail / Articles List ── */
                    <IssueArticlesView
                        issue={activeIssue.issue}
                        volume={activeIssue.volume}
                        onBack={closeIssue}
                        onViewPdf={openViewer}
                    />
                ) : (
                    /* ── Volume/Issue Grid ── */
                    <>
                        {archivesData.map((vol) => (
                            <div className="archives-volume-card" key={vol.volume}>
                                {/* Volume header */}
                                <div className="archives-volume-header">
                                    <div className="archives-volume-icon"><IconBook /></div>
                                    <div className="archives-volume-title-group">
                                        <h2 className="archives-volume-title">Volume {vol.volume}</h2>
                                        <span className="archives-volume-year">{vol.year}</span>
                                    </div>
                                </div>

                                {/* Issue grid */}
                                <div className="archives-issue-grid">
                                    {vol.issues.map((iss) => {
                                        const isPublished = iss.status === 'published';

                                        return (
                                            <div
                                                className={`archives-issue-card ${!isPublished ? 'coming-soon-card' : ''}`}
                                                key={iss.issue}
                                            >
                                                <div className="archives-issue-card-header">
                                                    <span className="archives-issue-number">Issue {iss.issue}</span>
                                                    <span className={`archives-issue-status ${iss.status}`}>
                                                        {isPublished ? '● Published' : '◷ Coming Soon'}
                                                    </span>
                                                </div>

                                                <h3 className="archives-issue-title">{iss.title}</h3>
                                                <p className="archives-issue-meta">
                                                    {isPublished ? <IconCalendar /> : <IconClock />}
                                                    {iss.date}
                                                </p>

                                                <div className="archives-issue-action">
                                                    {isPublished ? (
                                                        <button
                                                            className="archives-issue-btn view-btn"
                                                            onClick={() => openIssue(iss, vol.volume)}
                                                        >
                                                            <IconEye /> View Issue
                                                        </button>
                                                    ) : (
                                                        <span className="archives-issue-btn disabled-btn">
                                                            Upcoming
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}

                        {/* ── Call for Papers CTA ── */}
                        <div className="archives-cta-section">
                            <div className="archives-cta-card">
                                <div className="archives-cta-text">
                                    <h3>Call for Papers</h3>
                                    <p>
                                        Submit your research to the next issue of ITME. We welcome original manuscripts across all engineering disciplines.
                                    </p>
                                </div>
                                <Link to="/form" className="archives-cta-btn">
                                    <IconSend /> Submit Manuscript
                                </Link>
                            </div>
                        </div>
                    </>
                )}
            </div>

            {/* ── PDF Viewer Modal ── */}
            {viewerOpen && (
                <PdfViewerModal
                    pdfUrl={activePdf.url}
                    title={activePdf.title}
                    onClose={closeViewer}
                />
            )}
        </div>
    );
};

export default Archives;
